export const ru = {
    recommendation: 'Рекомендации'
};
